import Cookies from 'js-cookie'

export const checkUserTypeAndToken = () => {
    const userType = Cookies.get('usertype');

    if (!userType) {
        return false;
    }

    if (userType === '0') {
        const token = Cookies.get('token');

        if (!token) {
            return false;
        }
    }

    return true;
}
